module.exports = __webpack_public_path__ + "static/media/kosovo.144fe6cb.png";